import axiosInstance from '../../config/axiosInstance';
import {
  AssignRolesPayload,
  CreateRolePayload,
  DeleteRoleOptions,
  PermissionGroupV2,
  RoleV2,
  UpdateRolePayload,
} from '../../types/role';

export class RoleService {
  private readonly ROLES_PATH = '/roles';
  private readonly PERMISSIONS_PATH = '/permissions';
  private readonly USERS_PATH = '/users';

  async listRoles(): Promise<RoleV2[]> {
    return axiosInstance.get(this.ROLES_PATH);
  }

  async getRole(id: string): Promise<RoleV2> {
    return axiosInstance.get(`${this.ROLES_PATH}/${id}`);
  }

  async listPermissions(): Promise<PermissionGroupV2[]> {
    return axiosInstance.get(this.PERMISSIONS_PATH);
  }

  async createRole(payload: CreateRolePayload): Promise<RoleV2> {
    return axiosInstance.post(this.ROLES_PATH, payload);
  }

  async updateRole(id: string, payload: UpdateRolePayload): Promise<RoleV2> {
    return axiosInstance.patch(`${this.ROLES_PATH}/${id}`, payload);
  }

  async deleteRole(
    id: string,
    options: DeleteRoleOptions = {},
  ): Promise<{ deleted: true }> {
    return axiosInstance.delete(`${this.ROLES_PATH}/${id}`, {
      params: options,
    });
  }

  async assignUserRoles(
    userId: string,
    payload: AssignRolesPayload,
  ): Promise<unknown> {
    return axiosInstance.patch(
      `${this.USERS_PATH}/${userId}/roles`,
      payload,
    );
  }
}

export const roleService = new RoleService();
